// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1LSaq","containerItemsCenter":"Skeleton_containerItemsCenter__3zR-G"};